<template>
  <div>

    <div class="container-xl">
       <div class="logo">
        <router-link to="/sign"
          ><img src="../img/branogo2x.png" alt="" />会员专区</router-link
        >
      </div>
      <div class="Forget">
        <div class="reset">
          <h2>忘记密码</h2>
          <p style="margin-top: 50px">
            我们会把新的密码发送到以下邮箱，请填写正确邮箱
          </p>
          <van-field v-model="mail" label="邮箱" placeholder="请输入邮箱" />
          <button @click="sign" class="send">发送邮件</button>
          <h3>忘记邮箱</h3>
          <p>请直接联络你的牙医 / 诊所负责人</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/forget'
    },{
      rel:'alternate',
      href:'https://mybeame.com/forget',
      hrefLang:'x-default'
    }
    ]
  },
  data() {
    return {
      mail: "",
      uresData: {},
    };
  },
  methods: {
    //返回上一层
    back() {
      this.$router.go(-1);
    },
    //发送改密码事件
    sign() {
      if (this.mail == "") {
        this.$message({
          message: "请输入邮箱",
          type: "warning",
        });
        return;
      }

      this.subData = Object.assign(this.uresData);
      var uresData = {
        mail: this.mail,
      };
      //改密码请求
      sendMail(uresData).then((res) => {
        if (res.code == 200) {
          this.$dialog
            .alert({
              message: "发送成功",
            })
            .then(() => {
              this.$router.push("/sign");
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
.logo {
  display: flex;
  align-items: center;
  padding: 8px 0;
  background: #00e467;
}
.logo > a {
  margin-left: 5%;
  font-weight: 700;
  font-size: 21px;
}
.logo > a > img {
  width: 28px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.Forget {
  text-align: center;
  background-image: url(../img/n1.png);
  background-size: 100%;
}

.return {
  width: 6%;
  margin-left: 5%;
}
.reset > h2 {
  font-size: 32px;
  font-weight: 700;
  margin-top: 100px;
}
.reset > p {
  padding: 0 10%;
  font-weight: 500;
  color: #151515;
}
.reset > h3 {
  font-size: 21px;
  font-weight: 600;
  margin: 0 0 10px 0;
}
.van-cell {
  width: 35%;
  border: 2px solid #00e467;
  border-radius: 10px;
  margin: auto;
  margin-top: 20px;
}
.van-radio-group--horizontal {
  font-size: 15px !important;
  font-weight: 700;
}
.send {
  width: 35%;
  height: 44px;
  font-size: 16px;
  background: #00e467;
  border: none;
  margin-top: 20px;
  margin-bottom: 60px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 0px 10px 0px 0px;
  color: #323e48 !important;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 570px) {
  .reset > h2 {
    font-size: 27px;
  }
  .van-cell {
    width: 90%;
  }
  .send {
    width: 90%;
  }
  .reset > h3 {
    font-size: 19px;
  }
}
</style>
